<template lang="html">

  <div class="productos">

    <section class="middle-intro row-start">

      <div class="container">
        <h1 class="title -intro">{{$t('productos_list.titleProduct')}}</h1>
          <img src="/static/img/gifs/home-azul-blanco.gif" class="imagen-animacion" alt="imagen animcacion">
          <div class="titleIntro">     
              <h3 class="title -main" v-html="$t('productos_list.title')"></h3>
              <h2 class="title pequeño">{{$t('productos_list.subtitle')}}</h2></div>   
      </div>

    </section>

    <productos-list></productos-list>

  </div>

</template>

<script lang="js">

  import ProductosList from '@/components/parts/productos-list';

  export default  {
    name: 'productos',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    components: {
      'productos-list' : ProductosList
    }
  }
</script>

<style scoped >
.middle-intro {
  margin-bottom: 200px;
}
.title {
  font-size: 36px;
  color: #3374b0;
  margin-bottom: 40px;
}

.title.-main {
  margin-bottom: 0;
}
.titleIntro{
      width: calc(100% - 485px);
}
@media screen and (max-width:1920px){
	.middle-intro{
		margin-bottom: 110px;
	}
}
@media screen and (max-width: 1000px){
	.titleIntro{
		width: 100%;
  }
  .middle-intro{
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/productos.vue